import { useSelector } from 'react-redux';

import { hasScope } from 'selectors/scopes';

export function useHasSomeScopes(names) {
  const scopes = [].concat(names);

  return useSelector(state => scopes.some(scope => hasScope(state, scope)));
}

export function useHasAllScopes(names) {
  const scopes = [].concat(names);

  return useSelector(state => scopes.every(scope => hasScope(state, scope)));
}

export function useHasScope(name) {
  return useHasAllScopes([name]);
}
